// extracted by mini-css-extract-plugin
export default {"toggle-box":"Role_Selection_toggle-box__e9pDF"};